<template>
    <div>
        <div class="app-title">
            <em-view-title :crudState="$_emCommonListMixin_pathType"></em-view-title>
        </div>
        <section class="app-content" v-menu-permission="'list'">
            <div id="accordionFilter" class="content">
                <div class="card">
                    <div id="collapseOne" class="collapse show" aria-labelledby="headingOne"
                         data-parent="#accordionFilter">
                        <div class="card-body">
                            <form>
                                <em-filter :entity="modelName" ref="emListFilter" :ignoreMaxTableItemLimit="true"
                                           :query-api="openQuery"
                                           :$_em-custom-vuex-mixin_entity="$_emCustomVuexMixin_entity"
                                           :$_em-custom-vuex-mixin_filter="$_emCustomVuexMixin_filter"
                                           :$_em-custom-vuex-mixin_vo="$_emCustomVuexMixin_vo"
                                           @showEntityModalSelect="$_emCommonModalMixin_showModalSelectorByFilter"></em-filter>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
            <div id="sithMesStoolPoResultTable" class="content">
                <div class="card my-1">
                    <div id="collapseTwo" class="collapse show" aria-labelledby="headingTwo"
                         data-parent="#accordionResult">
                        <div class="card-body">
                            <em-table :entity="modelName" :ignoreMaxTableItemLimit="true"
                                      :ignoreAdd="true" :ignoreDelete="true" :editDisable="true"
                                      detailInlineButtonType="showAttachmentEntity"
                                      ref="emTable" :inlineActionsDisabled="prop_inline!=='1'" :query-api="openQuery"
                                      :useCustomFieldsDefaultFlag="false"
                                      withCustomRowActions
                                      @linkClick="handleLinkClick"
                                      :$_em-custom-vuex-mixin_entity="$_emCustomVuexMixin_entity"
                                      :$_em-custom-vuex-mixin_filter="$_emCustomVuexMixin_filter"
                                      :$_em-custom-vuex-mixin_vo="$_emCustomVuexMixin_vo"
                                      :custom-form-class="customFormClass"
                                      @showModalSelectorByNewRow="$_emCommonModalMixin_showModalSelectorByNewRow"
                                      @showModalSelectorByEditRow="$_emCommonModalMixin_showModalSelectorByEditRow">
                                <template #customRowActions="{row}">
                                    <b-button-group>
                                        <em-button type="gotoTransport" v-bind:class="'btn btn-outline-primary btn-sm'"
                                                   @click="gotoTransport(row)">
                                        </em-button>
                                    </b-button-group>
                                </template>
                                <template #left-header>
                                    <b-button
                                        :disabled="notSelected"
                                        variant="outline-primary"
                                        size="sm"
                                        @click="dialogDeliverInfoVisible = true">交货信息维护(OM)
                                    </b-button>
                                    <b-button
                                        :disabled="notSelected"
                                        variant="outline-primary"
                                        size="sm"
                                        @click="dialogConfirmDateVisible = true">确认到货日期
                                    </b-button>
                                    <b-button
                                        :disabled="notSelected"
                                        variant="outline-primary"
                                        size="sm"
                                        @click="dialogConfirmTypeVisible = true">回写SAP
                                    </b-button>
                                    <b-button
                                        :disabled="notSelected"
                                        variant="outline-primary"
                                        size="sm"
                                        @click="dialogDeleteConfirmTypeVisible = true">删除Confirm信息
                                    </b-button>
                                    <em-button
                                        type="uploadFile"
                                        class="btn btn-outline-primary btn-sm"
                                        :disabled="notSelected"
                                        custom-label="上传附件"
                                        :busy="saveAttachmentLoading"
                                        @click="openAttachmentModal">
                                    </em-button>
                                    <b-button
                                        :disabled="selectedNotEqualOne"
                                        variant="outline-primary"
                                        size="sm"
                                        @click="openContractAttachmentModal">上传合同（备用）
                                    </b-button>
                                    <batch-upload-attachment-with-store
                                        title="批量上传质量文件"
                                        attachmentFieldName="qualityFileIds"
                                        :modelName="modelName"
                                        :doQuery="doQuery"
                                        :voName=$_emCustomVuexMixin_vo
                                    />
                                    <b-button
                                        variant="outline-primary"
                                        size="sm"
                                        :disabled="notSelected"
                                        @click="receiveGrn()">GRN收货
                                    </b-button>
                                    <em-button
                                        type="uploadFile"
                                        class="btn btn-outline-primary btn-sm"
                                        :disabled=false
                                        custom-label="导入更新供货日期" show-name
                                        :busy="uploadFile"
                                        @click="openFileUpload">
                                    </em-button>
                                    <b-button
                                        :disabled="notSelected"
                                        variant="outline-primary"
                                        size="sm"
                                        @click="readChangeHistories"
                                    >已读需求日期变更
                                    </b-button>
                                    <mini-button :disable="$_notChecked" :loading="downloadLoading"
                                                 @btnClick="$_downloadBomDrawing">
                                        <i class="fa-solid fa-file-zipper"></i>
                                        技术文件下载
                                    </mini-button>
                                </template>
                            </em-table>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <em-modal-entity-selector ref="emModalEntitySelector"></em-modal-entity-selector>
        <el-dialog title="交货信息维护" :visible.sync="dialogDeliverInfoVisible">
            <el-form :inline="true">
                <el-form-item label="交货地点">
                    <el-input v-model="location" autocomplete="off"></el-input>
                </el-form-item>
                <el-form-item label="需求日期">
                    <el-date-picker
                        value-format="yyyy-MM-dd HH:mm:ss"
                        v-model="prdScheduleDate"
                        type="datetime"
                        placeholder="选择日期">
                    </el-date-picker>
                </el-form-item>
                <el-input
                    type="textarea"
                    style="width: 85%; margin-left: 50px;"
                    :rows="2"
                    placeholder="请输入原因"
                    v-model="remark">
                </el-input>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogDeliverInfoVisible = false">取 消</el-button>
                <el-button type="primary" @click="supportDeliverInfo">确 定</el-button>
            </div>
        </el-dialog>
        <el-dialog title="请选择确认类别" :visible.sync="dialogConfirmTypeVisible">
            <el-form :inline="true">
                <el-form-item label="确认类别">
                    <el-select v-model="confirmType" multiple placeholder="请选择">
                        <el-option v-for="item in confirmOptions" :key="item.value" :label="item.label"
                                   :value="item.value">
                        </el-option>
                    </el-select>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogConfirmTypeVisible = false">取 消</el-button>
                <el-button type="primary" @click="returnToSap()">确 定</el-button>
            </div>
        </el-dialog>
        <el-dialog title="请选择确认类别" :visible.sync="dialogDeleteConfirmTypeVisible">
            <el-form :inline="true">
                <el-form-item label="确认类别">
                    <el-select v-model="confirmType" multiple placeholder="请选择">
                        <el-option v-for="item in confirmOptions" :key="item.value" :label="item.label"
                                   :value="item.value">
                        </el-option>
                    </el-select>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogDeleteConfirmTypeVisible = false">取 消</el-button>
                <el-button type="primary" @click="deleteConfirmInSap()">确 定</el-button>
            </div>
        </el-dialog>
        <el-dialog title="请选择审批人" :visible.sync="dialogApproversVisible">
            <el-form :inline="true">
                <el-form-item label="审批人1">
                    <el-select filterable v-model="approver1" multiple placeholder="请选择">
                        <el-option v-for="item in approvers" :key="item.value" :label="item.label"
                                   :value="item.value">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="审批人2">
                    <el-select filterable v-model="approver2" multiple placeholder="请选择">
                        <el-option v-for="item in approvers" :key="item.value" :label="item.label"
                                   :value="item.value">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="审批人3">
                    <el-select filterable v-model="approver3" multiple placeholder="请选择">
                        <el-option v-for="item in approvers" :key="item.value" :label="item.label"
                                   :value="item.value">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="数量">
                    <el-input v-model="grnQuantity" placeholder="请输入数量" type="number"></el-input>
                </el-form-item>
                <el-form-item label="附件">
                    <multi-attachment class="w-100"
                                      :query-api="attachmentQueryApi"
                                      @loading="attachmentLoading"
                                      @idsChanged="changeAttachmentIds"
                                      :attachment-ids="attachmentIds">
                    </multi-attachment>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogApproversVisible = false">取 消</el-button>
                <el-button type="primary" @click="saveGrnTask()">确 定</el-button>
            </div>
        </el-dialog>
        <el-dialog title="确认到货日期" :visible.sync="dialogConfirmDateVisible">
            <el-form>
                <el-row>
                    <el-col :span="8">
                        <el-form-item label="请选择确认类型" label-width="auto">
                            <el-select v-model="confirmType" placeholder="请选择">
                                <el-option v-for="item in confirmOptions" :key="item.value" :label="item.label"
                                           :value="item.value">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="8">
                        <el-form-item label="请输入合适的确认到货日期:" label-width="auto">
                            <el-date-picker
                                value-format="yyyy-MM-dd HH:mm:ss"
                                v-model="confirmDate"
                                type="datetime"
                                placeholder="选择日期">
                            </el-date-picker>
                        </el-form-item>
                    </el-col>
                    <el-col :span="8">
                        <el-form-item label="reference">
                            <el-input v-model="reference"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogConfirmDateVisible = false">取 消</el-button>
                <el-button type="primary" @click="confirmDeliverDate()">确 定</el-button>
            </div>
        </el-dialog>
        <ReBModal header="上传附件"
                  @ok="submitAttachmentChange"
                  ref="uploadAttachment">
            <multi-attachment class="w-100"
                              :query-api="attachmentQueryApi"
                              @loading="attachmentLoading"
                              @idsChanged="changeAttachmentIds"
                              :attachment-ids="attachmentIds"></multi-attachment>
        </ReBModal>
        <ReBModal header="上传合同附件"
                  @ok="submitContractAttachmentChange"
                  ref="uploadContractAttachment">
            <multi-attachment class="w-100"
                              :query-api="attachmentQueryApi"
                              @loading="attachmentLoading"
                              @idsChanged="changeAttachmentIds"
                              :attachment-ids="attachmentIds"></multi-attachment>
        </ReBModal>
        <ReBModal header="交货日期操作记录"
                  large
                  ref="infoRecordList">
            <div class="d-flex flex-row mb-3" v-if="showDateFilter">
                <diverse-input :value.sync="infoRecordDateFrom" :config="infoRecordDateFromConfig" horizontal
                               class="col w-auto"></diverse-input>
                <diverse-input :value.sync="infoRecordDateEnd" :config="infoRecordDateEndConfig" horizontal
                               class="col w-auto"></diverse-input>
                <button class="btn btn-primary col-md-1" type="button" v-on:click="getInfoRecords(2)">
                    <span class="text">{{ $t("btn.basic.search") }}</span>
                </button>
            </div>

            <mini-table ref="infoRecordListResultTable"
                        read-only
                        needModelFields
                        :items="infoRecordList"
                        :fields="fields"
                        customVuexName="subview"
                        style="min-height: 350px;"
                        entity-name="sithMesPrdInfoRecord">
            </mini-table>
        </ReBModal>
        <b-modal id="modal-import" ref="importModal" title="导入数据" hide-footer>
            <b-form @submit="handleSubmit" @reset="handleReset">
                <b-form-group
                    id="templateFile"
                    label="选择数据源文件:"
                    label-for="input-dataFile"
                    invalid-feedback="必须选择数据源">
                    <b-form-file id="input-dataFile" v-model="file" ref="file-input" class="mb-2"
                                 :browse-text="$t('btn.basic.browse')" placeholder="请选择数据文件"
                                 :file-name-formatter="formatNames"
                                 accept=".xls,.xlsx" required></b-form-file>
                </b-form-group>
                <b-row align-h="end" style="margin-top: 30px">
                    <b-button type="submit" variant="primary">导入</b-button>
                    <b-button type="reset" variant="light">取消</b-button>
                </b-row>
            </b-form>
        </b-modal>
        <re-b-modal ref="requireDateChangeHistory" header="需求日期操作记录"
                    hide-footer superLarge fit-content>
            <mini-table ref="requireDateChangeHistoryTable"
                        read-only
                        needModelFields
                        :items="requireDateChangeHistories"
                        customVuexName="subview"
                        style="min-height: 350px;"
                        entity-name="sithMesStoolRequireDateChangeHistory">
            </mini-table>
        </re-b-modal>
    </div>
</template>
<script>
// Author Shi Wen Long
// Date 2021-07-06 09:52:28

import emCommonListMixin from "@/mixin/em/common/list";
import emCommonApiMixin from "@/mixin/em/common/api";
import emCommonGotoMixin from "@/mixin/em/common/goto";
import commonViewsUtil from "@/utils/commonViewsUtil";
import MultiAttachment from "@/components/echarts-part/stuff/MultiAttachment";
import ReBModal from "@/components/echarts-part/CalendarShift/cells/stuffs/ReBModal";
import MiniTable from "@/components/common/mini-table/MiniTable.vue";
import DiverseInput from "@/components/workflow/stuffs/DiverseInput";
import infoRecordOperationMixin from "@/mixin/em/common/stuffs/infoRecord/infoRecordOperationMixin";
import BatchUploadAttachmentWithStore from "@/components/common/attachment/BatchUploadAttachmentWithStore";
import emCustomVuexMixin from "@/mixin/em/customVuex";
import stoolPoMixin from "../../../mixin/em/common/stuffs/stool/stoolPoMixin";
import PageMaterialDownloadBomDrawingMixin from "@/views/sithMesII/pds/stuffs/page-material-download-bom-drawing-mixin";
import MiniButton from "@/components/common/buttons/MiniButton.vue";

export default {
    name: "sithMesStoolPoListView",
    components: {MiniButton, MultiAttachment, ReBModal, MiniTable, DiverseInput, BatchUploadAttachmentWithStore},
    mixins: [emCommonListMixin, emCommonApiMixin, emCommonGotoMixin, commonViewsUtil, infoRecordOperationMixin,
        emCommonListMixin, emCustomVuexMixin, stoolPoMixin, PageMaterialDownloadBomDrawingMixin],
    data() {
        return {
            dialogDeliverInfoVisible: false,
            file: null,
            dialogConfirmTypeVisible: false,
            dialogApproversVisible: false,
            dialogDeleteConfirmTypeVisible: false,
            dialogConfirmDateVisible: false,
            saveAttachmentLoading: false,
            uploadFile: false,
            prdScheduleDate: '',
            location: '',
            attachmentIds: '',
            confirmType: [],
            approver3: [],
            approver2: [],
            approver1: [],
            grnReport: '',
            openQuery: 'findAllByOpen',
            confirmOptions: [
                {
                    label: 'AB',
                    value: 'AB'
                }, {
                    label: 'LA',
                    value: 'LA'
                }
            ],
            approvers: [],
            confirmDate: '',
            reference: '',
            remark: '',

            grnQuantity: null,
        }
    },
    props: {
        //是否启用行编辑
        prop_inline: {
            type: String,
            default: "0"
        },
        $_emCustomVuexMixin_vo: {
            type: String,
            default: 'sithVo'
        },
        $_emCustomVuexMixin_filter: {
            type: String,
            default: 'sithFilter'
        },
    },
    created() {
        this.getOperationCount(2)
    },
    computed: {
        modelName() {
            return 'sithMesStoolPo';
        },
        attachmentQueryApi() {
            return `${process.env.VUE_APP_SITHMES_PRD_URL}/${this.modelName}/getAttachmentList`;
        },
        entityBaseUrl() {
            return `${this.$_emApiMixin_entityBaseApi(this.modelName)}/`
        },
        headers() {
            let headers = {}
            let jwt = localStorage['em_sso_token']
            if (jwt != null) {
                headers['Authorization'] = jwt;
            }
            return headers;
        },
        $_customVuexName() {
            return 'sith';
        },
        $_rowMaterialKey() {
            return 'materialNumber';
        }
    },
    methods: {
        supportDeliverInfo() {
            this.dialogDeliverInfoVisible = false;
            let arr = this.selectedItems.map(row => {
                let temp = {};
                temp.id = row.id;
                temp.prdScheduleDate = this.prdScheduleDate;
                temp.deliverLocation = this.location;
                temp.remark = this.remark;
                return temp;
            });
            let confirmDeliverUrl = this.$store.state.sithMesStoolPo.baseModuleUrl + "/sithMesStoolPo/updateDeliverInfo";
            this.$_emApiMixin_post(confirmDeliverUrl, arr).then(() => {
                commonViewsUtil.showSuccess(this, "操作成功！");
                this.getOperationCount(2)
                this.$refs['emListFilter'].doQuery();
            });
        },
        confirmDeliverDate() {

            this.dialogConfirmDateVisible = false;
            let arr = this.selectedItems.map(row => {
                row.reference = this.reference;
                if (this.confirmType === 'AB') {
                    row.deliveryDateAb = this.confirmDate;
                } else if (this.confirmType === 'LA') {
                    row.deliveryDateLa = this.confirmDate;
                }
                return row;
            });
            let confirmDeliverUrl = this.$store.state.sithMesStoolPo.baseModuleUrl + "/sithMesStoolPo/confirmDeliverDate";
            this.$_emApiMixin_post(confirmDeliverUrl, arr).then(() => {
                commonViewsUtil.showSuccess(this, "操作成功！");
                this.$refs['emListFilter'].doQuery();
            });
            this.confirmType = [];
        },
        submitAttachmentChange() {
            this.saveAttachmentLoading = true;
            let api = process.env.VUE_APP_SITHMES_PRD_URL + "/" + this.modelName + "/upload/attachment";
            this.$_emApiMixin_put(api, {
                ids: this.$_emCustomVuexMixin_checkItems,
                poReport: this.attachmentIds === undefined ? "" : this.attachmentIds
            }).then(() => {
                this.$message.success("保存成功");
                this.$refs.emListFilter.doQuery();
            }).finally(() => this.saveAttachmentLoading = false);
        },
        submitContractAttachmentChange() {
            let api = process.env.VUE_APP_SITHMES_PRD_URL + "/" + this.modelName + "/upload/attachment";
            this.$_emApiMixin_put(api, {
                ids: this.$_emCustomVuexMixin_checkItems,
                poContractReport: this.attachmentIds === undefined ? "" : this.attachmentIds
            }).then(() => {
                this.$message.success("保存成功");
                this.$refs.emListFilter.doQuery();
            });
        },
        attachmentLoading(val) {
            this.$refs.uploadAttachment.changeLoading(val);
        },
        openAttachmentModal() {
            this.attachmentIds = this.selectedItems[0].poReport;
            this.$refs.uploadAttachment.showModal();
        },
        openFileUpload() {
            this.file = null;
            this.$refs.importModal.show();
        },
        openContractAttachmentModal() {
            this.attachmentIds = this.selectedItems[0].poContractReport;
            this.$refs.uploadContractAttachment.showModal();
        },
        receiveGrn() {

            for (let item of this.selectedItems) {
                if (item.accountAssignmentCategory === 'D' || item.accountAssignmentCategory === 'Q') {
                    this.$message.error("[PO:" + item.purchasingDocNumber + ", Item:" + item.purchasingDocItemNumber + "]账目分类为"+item.accountAssignmentCategory+"，不能101收货！");
                    return;
                }  else if (item.accountAssignmentCategory === null || item.accountAssignmentCategory.length === 0) {
                    this.$message.error("[PO:" + item.purchasingDocNumber + ", Item:" + item.purchasingDocItemNumber + "]账目分类空，不能101收货！");
                    return;
                }
            }

            this.dialogApproversVisible = true;
            this.approvers = [];
            this.grnQuantity = this.selectedItems[0].purchaseOrderQuantity;
            var url = this.$store.state.emAclUser.baseModuleUrl + "/emAclRoleUser/getUserByRoleCode?code=grn_approver";
            this.$store.dispatch("api/get", {url})
                .then(data => {
                    data.forEach((item) => {
                        this.approvers.push({value: item['loginName'], label: item['name'] + '-' + item['loginName']});
                    });
                });

        },
        saveGrnTask() {

            this.dialogApproversVisible = false;

            let ids = [];
            let poNumbers = [];
            let poItems = [];

            this.selectedItems.forEach((row) => {
                ids.push(row.id);
                poNumbers.push(row.purchasingDocNumber);
                poItems.push(row.purchasingDocItemNumber);
            });

            let entity = {

                'purchasingDocId': ids.join(','),
                'purchasingDocNumber': poNumbers.join(','),
                'purchasingDocItemNumber': poItems.join(','),
                'approver1': this.approver1.join(','),
                'approver2': this.approver2.join(','),
                'approver3': this.approver3.join(','),
                'grnReport': this.attachmentIds === undefined ? "" : this.attachmentIds,
                'quantity': this.grnQuantity
            };

            if (entity.grnReport === null || entity.grnReport === '') {
                this.$message.warning("附件为空，GRN收货需要上传证明！");
                return;
            }

            let param = {'entity': 'sithMesStoolGrn'};
            param.entityAux = entity;
            this.$store.dispatch('emBase/emBaseCustomSave', param)
                .then(() => {
                    commonViewsUtil.showSuccess(this, "申请完成！");
                });

        },
        changeAttachmentIds(ids) {
            this.attachmentIds = ids;
        },
        returnToSap() {
            if (!this.confirmType.length) {
                this.$message.warning("未选择确认类别！");
                return;
            }

            let confirmTypes = this.confirmType.join('-');
            for (let item of this.selectedItems) {
                if (!item.deliveryDateAb && !item.deliveryDateLa) {
                    this.$message.warning("请完善供应商确认交货日期AB-LA！");
                    return;
                }
            }

            let url = this.$store.state.sithMesStoolPo.baseModuleUrl + "/sithMesStoolPo/returnToSap/" + confirmTypes;
            this.$_emApiMixin_post(url, this.selectedItems).then(response => {
                if (response.data) {
                    commonViewsUtil.showSuccess(this, "部分回写成功！");
                    commonViewsUtil.showWarning(this, response.data);
                } else {
                    commonViewsUtil.showSuccess(this, "全部回写成功！");
                }
                this.dialogConfirmTypeVisible = false;
            });
            this.confirmType = [];
        },
        deleteConfirmInSap() {
            if (!this.confirmType.length) {
                this.$message.warning("未选择确认类别！");
                return;
            }
            let confirmTypes = this.confirmType.join('-');
            let url = this.$store.state.sithMesStoolPo.baseModuleUrl + "/sithMesStoolPo/deleteConfirmInSap/" + confirmTypes;
            this.$_emApiMixin_post(url, this.selectedItems).then(response => {
                if (response.data) {
                    commonViewsUtil.showSuccess(this, "部分删除成功！");
                    commonViewsUtil.showWarning(this, response.data);
                } else {
                    commonViewsUtil.showSuccess(this, "全部删除成功！");
                }
                this.dialogDeleteConfirmTypeVisible = false;
            });
        },
        getDetailInlineButtonType(row) {
            if (row.poReport) {
                return 'showAttachmentEntity';
            }

            return 'showEntity';
        },
        //从Open PO页面跳转到运输申请页面
        gotoTransport(row) {
            this.$_emGotoMixin_gotoHolderList(
                "sithMesInventoryTransportApplication",
                {transPrFilter: row.purchaseRequisitionNumber},
                {},
                false,
                {pathType: "list"}
            );
        },
        doQuery() {
            this.$refs["emListFilter"].doQuery();
        },
        show() {
            this.file = null
            this.$refs["importModal"].show()
        },
        formatNames(files) {
            return files.length === 1 ? files[0].name : `${files.length} files selected`
        },
        handleSubmit(event) {
            event.preventDefault()
            let formData = new FormData();
            formData.append('file', this.file);

            this.$emit('begin');
            let url = this.$store.state.sithMesStoolPo.baseModuleUrl + "/sithMesStoolPo/importFileUpdateDeliveryDate"
            this.$_emApiMixin_post(url, formData)
                .then(response => {
                    commonViewsUtil.showSuccess(this, "更新成功")
                    //让页面刷新数据
                    this.$store.commit(`${this.entity}/setNeedToRefresh`, true, {
                        root: true
                    })
                }).finally(() => this.$emit('end'));

            this.$nextTick(() => {
                this.$bvModal.hide('modal-import')
            })
        },
        handleReset() {
            this.selectedMachineType = null;
            this.file = null;
            this.$nextTick(() => {
                this.$bvModal.hide('modal-import')
            })
        },
        customFormClass: (col, row) => {
            if (col.key === 'prdScheduleDate' && row.hasUnReadRequireDateChangeHistory === true) {
                return 'bg-danger text-white';
            }
            return '';
        },
    },
    mounted() {
        this.doQuery()
    }
};
</script>

<style lang="scss" scoped>
::v-deep .b-avatar.btn {
    border: 1px solid #1E5274 !important;
}
</style>
